import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-marketplace-shopping-cart-categories-landing',
  templateUrl: './cv-marketplace-shopping-cart-categories-landing.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart-categories-landing.component.scss']
})
export class CvMarketplaceShoppingCartCategoriesLandingComponent implements OnInit, OnDestroy {

  @Input() textFilter: string = '';
  @Input() selectedCategory: string;
  @Input() selectedTagsFilters: string[];
  @Output() clearAllFilters = new EventEmitter<void>();
  @Output() updateFilters = new EventEmitter<void>();
  @Output() showValidationMsg = new EventEmitter<any>();

  pscs: any = null;
  sortBy: string = 'PriceLowToHigh';
  productQuantity: number = 1;
  isVariationSelected: boolean = true;
  saleVariationFlag: boolean = false;
  sortOptions = [];
  selectedSortOption: any;
  localizationStrings = new Map();
  selectedTags: any[] = [];
  shouldShowTags: boolean = false;
  showLabel: boolean = false;
  marginRight: number = 70;
  labelTagWith: number = null;

  cardWidth: string = '0%';
  @ViewChild('productsLandingContainer') productsLandingContainerER: ElementRef;
  productsLandingContainerWidth: number = 0;
  productsLandingContainerObserver :any = null;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private cvLocalizationService: CVLocalizationService,
    private changeDetector?: ChangeDetectorRef,
  ) {
    this.pscs = shoppingCartService.shoppingCartObj;
  }

  @HostListener('window:resize', ['$event'])
  onResize(e: any) {
    setTimeout(() => {
        this.addLabel(0, 0, "onResize");
    }, 10)
  }

  ngOnInit(): void {
      this.loadData();
  }

  async loadData(){
    this.setCardsWidth(true);
    setTimeout(() => {
      this.pscs.shoppingCartIsProductSelected = false;
    }, 0);
    await this.loadLocalizations();
    if (this.pscs.shoppingCartActiveTab == this.getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY')) {
      if (this.pscs.shoppingCartLandingSortBy != '') {
        this.sortBy = this.pscs.shoppingCartLandingSortBy;
        let selectedSortOption = this.sortOptions.find(element => element.value == this.sortBy);
        if (selectedSortOption != null)
          this.selectedSortOption = selectedSortOption;
      } else {
        this.pscs.shoppingCartLandingSortBy = this.sortBy;
      }
      this.sortProducts(this.sortBy);
    } else {
      this.pscs.shoppingCartLandingSortBy = this.selectedSortOption;
      this.sortProducts(this.selectedSortOption);
    }
    this.pscs.shoppingCartActiveTab = this.getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY'); 
  }

  ngOnDestroy(): void {
    if (this.productsLandingContainerObserver) {
      this.productsLandingContainerObserver.disconnect();
    }
  }

  async loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
      this.localizationStrings = map;
      this.loadsortOptionsLocalizations();
    });
  }

  loadsortOptionsLocalizations() {
    this.sortOptions = [
      { value: 'PriceLowToHigh', name: this.getLocalizationString('Price_Low_To_High', 'Price: Low To High') },
      { value: 'PriceHighToLow', name: this.getLocalizationString('Price_High_To_Low', 'Price: High To Low') },
      { value: 'TitleAToZ', name: this.getLocalizationString('Title_A_To_Z', 'Title: A To Z') },
      { value: 'TitleZToA', name: this.getLocalizationString('Title_Z_To_A', 'Title: Z To A') }
    ];
    this.selectedSortOption = this.sortOptions[0];
  }

  getLocalizationString(key, defaultValue) {
    if (this.localizationStrings && this.localizationStrings.has(key))
      return this.localizationStrings.get(key);
    return defaultValue;
  }

  getVisibleProductsCount() {
    let count = 0;
    if (this.pscs.shoppingCartProducts != null) {
      this.pscs.shoppingCartProducts.forEach(product => {
        if (product.showItem)
          count++;
      });
    }
    return count;
  }

  getProductPrices(product) {
    if (product != null) {
      if (product.HasProductVariations && product.HasVariationPrices && product.VariationsData != null && product.VariationsData.length) {
        let initialVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue < currValue ? prev : curr;
        });
        let lastVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue > currValue ? prev : curr;
        });
        let initialVariationPrice = initialVariation.VariationOnSale ? (initialVariation.VariationPrice - (initialVariation.VariationPrice * (product.Sale / 100))) : initialVariation.VariationPrice;
        let lastVariationPrice = lastVariation.VariationOnSale ? (lastVariation.VariationPrice - (lastVariation.VariationPrice * (product.Sale / 100))) : lastVariation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(initialVariationPrice)) + " - " + new CvNumberLocalizePipe().transform(Math.ceil(lastVariationPrice));
      }
      else if (product.Sale != null && this.isCurrentSale(product)) {
        return product.CalculatedRealPrice;
      } else
        return product.Price;
    }
  }

  getImagesCount(product) {
    let count = 0;
    if (product.MultipleImagesData != null && product.MultipleImagesData.length > 1) {
      let mainImages = product.MultipleImagesData.filter((i) => { return i.PointStoreProductVariationID == null || i.PointStoreProductVariationID == 0; });
      count = mainImages != null ? mainImages.length : 0;

      if (product.VariationsData != null && product.VariationsData.length > 0) {
        let variationImages = product.VariationsData.map((v) => {
          if (v.Active == null || v.Active)
            return v.PointStoreProductVariationID;
        });
        product.MultipleImagesData.forEach((currentValue, index, array) => {
          if (variationImages.includes(currentValue.PointStoreProductVariationID))
            count++;
        });
      }
      return count - 1;
    } else {
      return 1
    }
  }

  isCurrentSale(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 1);
    }

    return false;
  }

  isFeatured(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 2);
    }

    return false;
  }

  sortProducts(sortBy) {
    if (sortBy == null)
      sortBy = this.sortBy
    else
      this.sortBy = sortBy;

    this.pscs.shoppingCartLandingSortBy = this.sortBy

    switch (this.sortBy) {
      case "PriceLowToHigh":
      default:
        this.pscs.shoppingCartProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceA) - parseFloat(priceB);
        });
        break;
      case "PriceHighToLow":
        this.pscs.shoppingCartProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceB) - parseFloat(priceA);
        });
        break;
      case "TitleAToZ":
        this.pscs.shoppingCartProducts.sort((a, b) => a.Title.localeCompare(b.Title));
        break;
      case "TitleZToA":
        this.pscs.shoppingCartProducts.sort((a, b) => b.Title.localeCompare(a.Title));
        break;
    }
  }

  modifySelectedTags($event) {
    let clearAllBtn = document.getElementById("clear-all-categories");
    if (clearAllBtn != null)
      clearAllBtn.style.visibility = "hidden";
    this.shouldShowTags = false;
    if ($event.action == 'add') {
      let found = this.selectedTags.find(tag => tag.name == $event.filter);
      if (found == null)
        this.selectedTags.push({ name: $event.filter });
    }
    if ($event.action == 'remove') {
      if ($event.filter == 'all') {
        this.selectedTags = [];
      }
      else if ($event.filter == 'category') {
        let tagsArray = [];
        this.selectedTags.forEach(tag => {
          if (tag.name ==  this.getLocalizationString('On_Sale', 'On Sale') || tag.name ==  this.getLocalizationString('Best_Sellers_Capitalized', 'Best Seller')) {
            tagsArray.push({ name: tag.name });
          }
        });
        this.selectedTags = tagsArray;
      }
      else {
        let index = this.selectedTags.map(c => c.name).indexOf($event.filter);
        if (index > -1) {
          this.selectedTags.splice(index, 1);
        }
      }
    }
    this.pscs.shoppingCartSelectedTags = this.selectedTags;
    this.changeDetector.detectChanges();
    this.shouldShowTags = true;
    setTimeout(() => {
      this.addLabel(0, 0, "modifySelectedTags");
      let tagContainer: any = document.getElementsByClassName("cxone-tags")[0];
      if (tagContainer != null) {
        let width = tagContainer.offsetWidth
        let clearAllBtn = document.getElementById("clear-all-categories");
        if (clearAllBtn != null)
        clearAllBtn.style.visibility = "visible";
      }
    }, 10)
  }

  addLabel(widthDelete: number, widthTagDelete: number, labelTexet) {
    let labelToRemovePrew = document.getElementById('clearId');    
    labelToRemovePrew? labelToRemovePrew?.remove() : null;
    this.showLabel = false;
    let labelStyle = {
        marginTop: "10px",
        fontFamily: "Lato, sans-serif", 
        fontSize: "12px",
        lineHeight: "16px",
        textAlign: "center",
        color: "#007CBE",
        cursor: "pointer",
        alignSelf: "end",
        marginLeft: "7px",
        fontWeight: "400",
    };

    let tagContainerSelect: any = document.getElementsByClassName("cxone-selected-tags")[0];
    let tagContainerTag: any = document.getElementsByClassName("cxone-tags")[0];

    if (tagContainerSelect && tagContainerTag) {
        let width = tagContainerSelect.offsetWidth;
        let widthTag = tagContainerTag.offsetWidth;
        width = widthDelete != 0? widthDelete : width;
        widthTag = widthTagDelete != 0 ? widthTagDelete : widthTag;
        let originalWithTag = widthTag; 
        let divWrapper = document.createElement('div');
        divWrapper.className = 'horizontal ng-star-inserted';
        divWrapper.id = 'clearId';
        let newLabel = document.createElement('label');
        newLabel.className = 'label-class';
        Object.assign(newLabel.style, labelStyle);
        newLabel.hidden = !(this.shouldShowTags && this.selectedTags.length > 0);
        newLabel.textContent =  this.getLocalizationString('Clear_All', 'Clear All');
        let self = this;
        newLabel.addEventListener("click", () => {
            self.clearAllFilters.emit();
            self.clearSelectedTags();
        });        
        
        divWrapper.appendChild(newLabel);
        let labelToRemove = document.getElementById('clearId');
        let labelToRemovePrew = document.getElementById('clearId');
        if (!this.labelTagWith && widthDelete == 0) {
            widthTag = widthTag + 56;
        } else if (this.labelTagWith && widthDelete == 0) {
            widthTag = widthTag + this.labelTagWith;
        }
        let cxoneTagsWrapper = document.querySelector('.cxone-tags');
        if (cxoneTagsWrapper && width >= widthTag) {   
            labelToRemove ? null : cxoneTagsWrapper.insertBefore(divWrapper, cxoneTagsWrapper.lastChild);
            this.showLabel = false;
            let labelToRemovePrewgg = document.getElementById('clearId');
            if (!this.labelTagWith) {
                this.labelTagWith = labelToRemovePrewgg ? labelToRemovePrewgg?.offsetWidth : null;
            }
         } else if (width  < widthTag) {            
            this.showLabel = true;
            let clearAllTag: any = document.getElementsByClassName("clearAll-label")[0];
            let clearAllTagWidth = clearAllTag ? clearAllTag?.offsetWidth : null;
            labelToRemove? labelToRemove?.remove() : null;
            let diff = width - originalWithTag - 5;
            diff = diff < 0 ? 5 : diff;
            this.marginRight = ((70 - (clearAllTagWidth - 41)) + diff);
        }
    }   
}


  clearSelectedTags() {
    this.selectedTags = [];
  }

  removeFilter(event) {
    this.updateFilters.emit(event.name);  
    setTimeout(() => {
        this.addLabel(0, 0, "removeFilter");
    }, 10)
   
  }

  isPriceLabelTooLong(product) {
    let value = String(this.getProductPrices(product));
    if (value.includes("-")) {
      return value.length > 11;
    } else {
      return new CvNumberLocalizePipe().transform(value).length > 6 && product.Sale != null && this.isCurrentSale(product);
    }
  }

  isOutOfStock(product): any {
    if (product != null) {
      if (product.HasProductVariations && product.VariationsData != null && product.VariationsData.length > 0) {
        let variationsOutOfStock = 0;
        product.VariationsData.forEach(variation => {
          if (variation.VariationQuantity === 0)
            variationsOutOfStock++;
        });
        return variationsOutOfStock == product.VariationsData.length;
      } else {
        return product.Quantity == 0 || product.Quantity < 0;
      }
    } else
      return false;
  }

  openProductDetails(product) {
    this.pscs.shoppingCartIsProductSelected = true;
    this.pscs.pointStoreDetailedViewProduct = product;
  }

  async wishlistAction(product, $event) {
    $event.stopPropagation();
    if (product.isInWhisList)
      await this.removeFromWishlist(product)
    else
      await this.addToWishlistProduct(product);

    if (this.sortBy != null) {
      this.sortProducts(this.sortBy);
    } else {
      this.pscs.shoppingCartLandingSortBy = this.selectedSortOption;
      this.sortBy = this.pscs.shoppingCartLandingSortBy;
      this.sortProducts(this.selectedSortOption);
    }
  }

  async removeFromWishlist(product) {
    let response = await this.shoppingCartService.removeWishlistItem(product);
    if (response) {
      this.showValidationMsg.emit({ event: event, isAdding: false });
    }
  }

  async addToWishlistProduct(product) {
    let response = await this.shoppingCartService.addWishlistItem(product);
    if (response) {
      this.showValidationMsg.emit({ event: event, isAdding: true });
    }
  }

  isMainImageEmptyWithMultiplesImages(product): boolean{
    return product.HasMultipleImages && (product.ProductImageID == 0 || product.ProductImageID == null);
  }

  getFirstVariationImage(product: any): any {
    let firstVariationImage;
    if(product && product.MultipleImagesData && product.MultipleImagesData.length > 0){
      firstVariationImage = product.MultipleImagesData[0].PointStoreProductImageID;
    }
    return firstVariationImage;
  }
  
  reduceLongPriceLength(longPrice: string): string{
    if (longPrice.length > 19){
      return (longPrice.substring(0, 17) + "...");
    } else{
      return longPrice;
    }
  }


  /**
   * calculate card width based on the content size.
   */
  calculateCardsWidth() {
    const upperTabsContent = document.getElementsByClassName('upper-tabs-content');
    if (upperTabsContent) {
      const elementFromUpperTabsContent = upperTabsContent[0] as HTMLElement;
      if (elementFromUpperTabsContent.offsetWidth >= 1770) {
        //7 cards by row
        this.cardWidth = '14.28571428571429%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1769 && elementFromUpperTabsContent.offsetWidth >= 1470) {
        //6 cards by row
        this.cardWidth = '16.66666666666667%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1469 && elementFromUpperTabsContent.offsetWidth >= 1270) {
        //5 cards by row
        this.cardWidth = '20%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1269 && elementFromUpperTabsContent.offsetWidth >= 1070) {
        //4 cards by row
        this.cardWidth = '25%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 1069 && elementFromUpperTabsContent.offsetWidth >= 830) {
        //3 cards by row
        this.cardWidth = '33.33%';
      } else if (elementFromUpperTabsContent.offsetWidth <= 829 && elementFromUpperTabsContent.offsetWidth >= 600) {
        //2 cards by row
        this.cardWidth = '50%';
      } else {
        //1 card by row
        this.cardWidth = '100%';
      }
    } else {
      this.cardWidth = '20%';
    }
  }

  /**
   * set the card width based on the width of 'upper-tabs-content', Use the calculateCardsWidth() function
   */
  setCardsWidth(firstLoading: boolean): void {
    this.calculateCardsWidth();
    this.changeDetector.detectChanges();
    if (firstLoading) {
      setTimeout(() => {
        this.configureCardsWidth();
        this.configureResizeObserver();
      }, 0);
    } else {
      this.configureCardsWidth();
    }
  }

  /**
   * configure the productsLandingContainerWidth variable. 
   */
  configureCardsWidth() {
    if (this.productsLandingContainerER) {
      this.productsLandingContainerWidth = this.productsLandingContainerER.nativeElement.offsetWidth;
    } else {
      this.productsLandingContainerWidth = 1;
    }
  }

  /**
   * configure resize observer
   */
  configureResizeObserver() {
    this.productsLandingContainerObserver = new ResizeObserver(entries => {
      if (this.productsLandingContainerER) {
        // Adjust the width of the card according to the width of the container.
        if (this.productsLandingContainerER.nativeElement.offsetWidth !== 0 &&
          this.productsLandingContainerWidth !== 0 &&
          this.productsLandingContainerER.nativeElement.offsetWidth !== this.productsLandingContainerWidth) {
          this.setCardsWidth(false);
        }
      }
    });
    const divToObserve = document.getElementById('products-landing-container');
    this.productsLandingContainerObserver.observe(divToObserve);
  }

}
